import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle<{ cartOpen: boolean }>`
    html, body, main {
        padding: 0;
        margin: 0;
        scroll-behavior: smooth;
    }
`;
